
// Easeing
jQuery.easing.jswing = jQuery.easing.swing; jQuery.extend(jQuery.easing, { def: "easeOutQuad", swing: function (x, t, b, c, d) { return jQuery.easing[jQuery.easing.def](x, t, b, c, d) }, easeInQuad: function (x, t, b, c, d) { return c * (t /= d) * t + b }, easeOutQuad: function (x, t, b, c, d) { return -c * (t /= d) * (t - 2) + b }, easeInOutQuad: function (x, t, b, c, d) { if ((t /= d / 2) < 1) { return c / 2 * t * t + b } return -c / 2 * ((--t) * (t - 2) - 1) + b }, easeInCubic: function (x, t, b, c, d) { return c * (t /= d) * t * t + b }, easeOutCubic: function (x, t, b, c, d) { return c * ((t = t / d - 1) * t * t + 1) + b }, easeInOutCubic: function (x, t, b, c, d) { if ((t /= d / 2) < 1) { return c / 2 * t * t * t + b } return c / 2 * ((t -= 2) * t * t + 2) + b }, easeInQuart: function (x, t, b, c, d) { return c * (t /= d) * t * t * t + b }, easeOutQuart: function (x, t, b, c, d) { return -c * ((t = t / d - 1) * t * t * t - 1) + b }, easeInOutQuart: function (x, t, b, c, d) { if ((t /= d / 2) < 1) { return c / 2 * t * t * t * t + b } return -c / 2 * ((t -= 2) * t * t * t - 2) + b }, easeInQuint: function (x, t, b, c, d) { return c * (t /= d) * t * t * t * t + b }, easeOutQuint: function (x, t, b, c, d) { return c * ((t = t / d - 1) * t * t * t * t + 1) + b }, easeInOutQuint: function (x, t, b, c, d) { if ((t /= d / 2) < 1) { return c / 2 * t * t * t * t * t + b } return c / 2 * ((t -= 2) * t * t * t * t + 2) + b }, easeInSine: function (x, t, b, c, d) { return -c * Math.cos(t / d * (Math.PI / 2)) + c + b }, easeOutSine: function (x, t, b, c, d) { return c * Math.sin(t / d * (Math.PI / 2)) + b }, easeInOutSine: function (x, t, b, c, d) { return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b }, easeInExpo: function (x, t, b, c, d) { return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b }, easeOutExpo: function (x, t, b, c, d) { return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b }, easeInOutExpo: function (x, t, b, c, d) { if (t == 0) { return b } if (t == d) { return b + c } if ((t /= d / 2) < 1) { return c / 2 * Math.pow(2, 10 * (t - 1)) + b } return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b }, easeInCirc: function (x, t, b, c, d) { return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b }, easeOutCirc: function (x, t, b, c, d) { return c * Math.sqrt(1 - (t = t / d - 1) * t) + b }, easeInOutCirc: function (x, t, b, c, d) { if ((t /= d / 2) < 1) { return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b } return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b }, easeInElastic: function (x, t, b, c, d) { var s = 1.70158; var p = 0; var a = c; if (t == 0) { return b } if ((t /= d) == 1) { return b + c } if (!p) { p = d * 0.3 } if (a < Math.abs(c)) { a = c; var s = p / 4 } else { var s = p / (2 * Math.PI) * Math.asin(c / a) } return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b }, easeOutElastic: function (x, t, b, c, d) { var s = 1.70158; var p = 0; var a = c; if (t == 0) { return b } if ((t /= d) == 1) { return b + c } if (!p) { p = d * 0.3 } if (a < Math.abs(c)) { a = c; var s = p / 4 } else { var s = p / (2 * Math.PI) * Math.asin(c / a) } return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b }, easeInOutElastic: function (x, t, b, c, d) { var s = 1.70158; var p = 0; var a = c; if (t == 0) { return b } if ((t /= d / 2) == 2) { return b + c } if (!p) { p = d * (0.3 * 1.5) } if (a < Math.abs(c)) { a = c; var s = p / 4 } else { var s = p / (2 * Math.PI) * Math.asin(c / a) } if (t < 1) { return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b } return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b }, easeInBack: function (x, t, b, c, d, s) { if (s == undefined) { s = 1.70158 } return c * (t /= d) * t * ((s + 1) * t - s) + b }, easeOutBack: function (x, t, b, c, d, s) { if (s == undefined) { s = 1.70158 } return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b }, easeInOutBack: function (x, t, b, c, d, s) { if (s == undefined) { s = 1.70158 } if ((t /= d / 2) < 1) { return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b } return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b }, easeInBounce: function (x, t, b, c, d) { return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b }, easeOutBounce: function (x, t, b, c, d) { if ((t /= d) < (1 / 2.75)) { return c * (7.5625 * t * t) + b } else { if (t < (2 / 2.75)) { return c * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75) + b } else { if (t < (2.5 / 2.75)) { return c * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375) + b } else { return c * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375) + b } } } }, easeInOutBounce: function (x, t, b, c, d) { if (t < d / 2) { return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * 0.5 + b } return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b } });

// Mobile
(function ($, window, document, undefined) { var dataPropertyName = "virtualMouseBindings", touchTargetPropertyName = "virtualTouchID", virtualEventNames = "vmouseover vmousedown vmousemove vmouseup vclick vmouseout vmousecancel".split(" "), touchEventProps = "clientX clientY pageX pageY screenX screenY".split(" "), mouseHookProps = $.event.mouseHooks ? $.event.mouseHooks.props : [], mouseEventProps = $.event.props.concat(mouseHookProps), activeDocHandlers = {}, resetTimerID = 0, startX = 0, startY = 0, didScroll = false, clickBlockList = [], blockMouseTriggers = false, blockTouchTriggers = false, eventCaptureSupported = "addEventListener" in document, $document = $(document), nextTouchID = 1, lastTouchID = 0; $.vmouse = { moveDistanceThreshold: 10, clickDistanceThreshold: 10, resetTimerDuration: 1500 }; function getNativeEvent(event) { while (event && typeof event.originalEvent !== "undefined") { event = event.originalEvent } return event } function createVirtualEvent(event, eventType) { var t = event.type, oe, props, ne, prop, ct, touch, i, j; event = $.Event(event); event.type = eventType; oe = event.originalEvent; props = $.event.props; if (t.search(/^(mouse|click)/) > -1) { props = mouseEventProps } if (oe) { for (i = props.length, prop; i;) { prop = props[--i]; event[prop] = oe[prop] } } if (t.search(/mouse(down|up)|click/) > -1 && !event.which) { event.which = 1 } if (t.search(/^touch/) !== -1) { ne = getNativeEvent(oe); t = ne.touches; ct = ne.changedTouches; touch = (t && t.length) ? t[0] : ((ct && ct.length) ? ct[0] : undefined); if (touch) { for (j = 0, len = touchEventProps.length; j < len; j++) { prop = touchEventProps[j]; event[prop] = touch[prop] } } } return event } function getVirtualBindingFlags(element) { var flags = {}, b, k; while (element) { b = $.data(element, dataPropertyName); for (k in b) { if (b[k]) { flags[k] = flags.hasVirtualBinding = true } } element = element.parentNode } return flags } function getClosestElementWithVirtualBinding(element, eventType) { var b; while (element) { b = $.data(element, dataPropertyName); if (b && (!eventType || b[eventType])) { return element } element = element.parentNode } return null } function enableTouchBindings() { blockTouchTriggers = false } function disableTouchBindings() { blockTouchTriggers = true } function enableMouseBindings() { lastTouchID = 0; clickBlockList.length = 0; blockMouseTriggers = false; disableTouchBindings() } function disableMouseBindings() { enableTouchBindings() } function startResetTimer() { clearResetTimer(); resetTimerID = setTimeout(function () { resetTimerID = 0; enableMouseBindings() }, $.vmouse.resetTimerDuration) } function clearResetTimer() { if (resetTimerID) { clearTimeout(resetTimerID); resetTimerID = 0 } } function triggerVirtualEvent(eventType, event, flags) { var ve; if ((flags && flags[eventType]) || (!flags && getClosestElementWithVirtualBinding(event.target, eventType))) { ve = createVirtualEvent(event, eventType); $(event.target).trigger(ve) } return ve } function mouseEventCallback(event) { var touchID = $.data(event.target, touchTargetPropertyName); if (!blockMouseTriggers && (!lastTouchID || lastTouchID !== touchID)) { var ve = triggerVirtualEvent("v" + event.type, event); if (ve) { if (ve.isDefaultPrevented()) { event.preventDefault() } if (ve.isPropagationStopped()) { event.stopPropagation() } if (ve.isImmediatePropagationStopped()) { event.stopImmediatePropagation() } } } } function handleTouchStart(event) { var touches = getNativeEvent(event).touches, target, flags; if (touches && touches.length === 1) { target = event.target; flags = getVirtualBindingFlags(target); if (flags.hasVirtualBinding) { lastTouchID = nextTouchID++; $.data(target, touchTargetPropertyName, lastTouchID); clearResetTimer(); disableMouseBindings(); didScroll = false; var t = getNativeEvent(event).touches[0]; startX = t.pageX; startY = t.pageY; triggerVirtualEvent("vmouseover", event, flags); triggerVirtualEvent("vmousedown", event, flags) } } } function handleScroll(event) { if (blockTouchTriggers) { return } if (!didScroll) { triggerVirtualEvent("vmousecancel", event, getVirtualBindingFlags(event.target)) } didScroll = true; startResetTimer() } function handleTouchMove(event) { if (blockTouchTriggers) { return } var t = getNativeEvent(event).touches[0], didCancel = didScroll, moveThreshold = $.vmouse.moveDistanceThreshold; didScroll = didScroll || (Math.abs(t.pageX - startX) > moveThreshold || Math.abs(t.pageY - startY) > moveThreshold), flags = getVirtualBindingFlags(event.target); if (didScroll && !didCancel) { triggerVirtualEvent("vmousecancel", event, flags) } triggerVirtualEvent("vmousemove", event, flags); startResetTimer() } function handleTouchEnd(event) { if (blockTouchTriggers) { return } disableTouchBindings(); var flags = getVirtualBindingFlags(event.target), t; triggerVirtualEvent("vmouseup", event, flags); if (!didScroll) { var ve = triggerVirtualEvent("vclick", event, flags); if (ve && ve.isDefaultPrevented()) { t = getNativeEvent(event).changedTouches[0]; clickBlockList.push({ touchID: lastTouchID, x: t.clientX, y: t.clientY }); blockMouseTriggers = true } } triggerVirtualEvent("vmouseout", event, flags); didScroll = false; startResetTimer() } function hasVirtualBindings(ele) { var bindings = $.data(ele, dataPropertyName), k; if (bindings) { for (k in bindings) { if (bindings[k]) { return true } } } return false } function dummyMouseHandler() { } function getSpecialEventObject(eventType) { var realType = eventType.substr(1); return { setup: function (data, namespace) { if (!hasVirtualBindings(this)) { $.data(this, dataPropertyName, {}) } var bindings = $.data(this, dataPropertyName); bindings[eventType] = true; activeDocHandlers[eventType] = (activeDocHandlers[eventType] || 0) + 1; if (activeDocHandlers[eventType] === 1) { $document.bind(realType, mouseEventCallback) } $(this).bind(realType, dummyMouseHandler); if (eventCaptureSupported) { activeDocHandlers.touchstart = (activeDocHandlers.touchstart || 0) + 1; if (activeDocHandlers.touchstart === 1) { $document.bind("touchstart", handleTouchStart).bind("touchend", handleTouchEnd).bind("touchmove", handleTouchMove).bind("scroll", handleScroll) } } }, teardown: function (data, namespace) { --activeDocHandlers[eventType]; if (!activeDocHandlers[eventType]) { $document.unbind(realType, mouseEventCallback) } if (eventCaptureSupported) { --activeDocHandlers.touchstart; if (!activeDocHandlers.touchstart) { $document.unbind("touchstart", handleTouchStart).unbind("touchmove", handleTouchMove).unbind("touchend", handleTouchEnd).unbind("scroll", handleScroll) } } var $this = $(this), bindings = $.data(this, dataPropertyName); if (bindings) { bindings[eventType] = false } $this.unbind(realType, dummyMouseHandler); if (!hasVirtualBindings(this)) { $this.removeData(dataPropertyName) } } } } for (var i = 0; i < virtualEventNames.length; i++) { $.event.special[virtualEventNames[i]] = getSpecialEventObject(virtualEventNames[i]) } if (eventCaptureSupported) { document.addEventListener("click", function (e) { var cnt = clickBlockList.length, target = e.target, x, y, ele, i, o, touchID; if (cnt) { x = e.clientX; y = e.clientY; threshold = $.vmouse.clickDistanceThreshold; ele = target; while (ele) { for (i = 0; i < cnt; i++) { o = clickBlockList[i]; touchID = 0; if ((ele === target && Math.abs(o.x - x) < threshold && Math.abs(o.y - y) < threshold) || $.data(ele, touchTargetPropertyName) === o.touchID) { e.preventDefault(); e.stopPropagation(); return } } ele = ele.parentNode } } }, true) } })(jQuery, window, document);
(function ($) {

    var defaults = {

        // Allmänt
        autoplay: true,
        hoverpause: true,
        responsive: true,
        swipe: true,
        bullets: true,
        arrow: true,
        tabs: true,
        count: true,
        fadeArrows: false,
        countSplit: " / ",
        preventClicking: true,
        // Gör så man inte kan klicka under animationen
        preventDragImage: true,
        // Gör så bilder inte fastnar vid muspekaren när man drar
        preloader: true,
        customstyle: true,
        customHeight: true,
        // Handle Equal Heights Sliders
        equalheight: false,

        // Arrows
        prevTxt: "",
        nextTxt: "",

        // Slide
        startIndex: 0,
        show: 1,
        slide: 1,

        // Effects
        transition: "fade",
        easing: "jswing",

        // Tid
        duration: 2000,
        transTime: 1400,

        // Tablet Landscape
        tablet_landscape_width: 1025,
        tablet_landscape_show: 1,
        tablet_landscape_slide: 1,

        // Tablet Portrait
        tablet_portrait_width: 980,
        tablet_portrait_show: 1,
        tablet_portrait_slide: 1,

        // Smartphone Landscape
        smartphone_landscape_width: 768,
        smartphone_landscape_show: 1,
        smartphone_landscape_slide: 1,

        // Smartphone Portrait
        smartphone_portrait_width: 481,
        smartphone_portrait_show: 1,
        smartphone_portrait_slide: 1
    }

    var pluginName = "tSlider";

    $.fn[pluginName] = function (options) {
        var args = arguments;
        if (options === undefined || typeof options === 'object') {
            // Skapar ett ny Pluginreferens för varje element, och lagrar det i datan för att lätt kunna ta bort det sen.
            return this.each(function () {
                if (!$.data(this, 'Mediascreen_' + pluginName)) {
                    this.slider = new Object();
                    $.data(this, 'Mediascreen_' + pluginName, new tSlider(this, options, true));
                } else {
                    if ($(this).find('.tSliderWindow').children('.slideWrp').length > 1) {
                        this.slider.setup = $.extend({}, this.slider.setup, options);
                        $.data(this, 'Mediascreen_' + pluginName);
                    }
                }
            });
        } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
            if (Array.prototype.slice.call(args, 1).length == 0 && $.inArray(options, $.fn[pluginName].getters) != -1) {
                var instance = $.data(this[0], 'Mediascreen_' + pluginName);
                return instance[options].apply(instance, Array.prototype.slice.call(args, 1));
            } else {
                // Om användaren skickar in argument hanterar vi dom här, t.ex "destroy", "init"
                return this.each(function () {
                    var instance = $.data(this, 'Mediascreen_' + pluginName);
                    if (instance instanceof tSlider && typeof instance[options] === 'function') {
                        instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                    }
                });
            }
        }

    };

    function tSlider(element, options, isinit) {
        var self = this;
        self.slider = element.slider;
        //// Hanterar flera element
        //// TODO: Om det failar, visa nått ???
        //if (this.length == 0) return this
        //else if (this.length > 1) this.each(function () {
        //    $(this).tSlider(options);
        //});

        // Namespace

        var firstDirection = "next";

        // Elements
        var el = $(element).find(".tSliderWindow");

        // Wrapper
        var wrap = $(element).find(".tSliderWrp");


        // Upplösning
        var windowWidth = $(window).outerWidth(true);
        var windowHeight = $(window).outerHeight(true);

        // Swipe
        var drag = null;
        var dragSX = null;
        var dragSY = null;
        var dragEX = null;
        var dragEY = null;
        var currentTime = 0;

        // Allmänt
        var preventClick = null;
        var preventDragImage = null;
        var oldIndex = 0;
        self.slider.oldIndex = 0;
        var prewraper = "";

        // Skriver värdena från defaults till namespace
        self.slider.setup = $.extend({}, defaults, options);
        self.interval


        // Göm alla slides
        el.children().css({
            "opacity": "0"
        });

        // Sortera array

        function asc(data_A, data_B) {
            return (data_A - data_B);
        }

        function desc(data_A, data_B) {
            return (data_B - data_A);
        }

        /* ============================================================
		   Tankbar Preloader
		   ============================================================ */

        var preloader = function () {
            setTimeout(function () {
                var total = el.find("img").length;
                wrap.append('<div id="preloader"><div class="loader"><img src="/wp-content/themes/kulturparlor/assets/images/loader.gif" /></div></div>');
                prewraper = wrap.find("#preloader");
                prewraper.width(el.children().outerWidth(true)).height(el.children().outerHeight(true)).css({
                    opacity: "1",
                    position: "relative",
                    width: "100%",
                    top: "0",
                    zIndex: "999999",
                    background: "transparent"
                });
                prewraper.find(".loader").css({
                    "position": "absolute",
                    "top": "50%",
                    "left": "50%",
                    "margin-left": "-20px",
                    "margin-top": "-20px"
                });

                if (total == 0) {
                    prefinished();
                }
                var counter = 0;
                $.each(el.find("img"), function (key, value) {
                    var img = new Image();
                    img.onload = function () {
                        counter++;
                        img.done();
                    }
                    img.done = function () {
                        if (counter == total) {
                            prefinished();
                        }
                    }
                    img.onerror = function () {
                        counter++;
                        img.done();
                    }
                    img.src = value.src
                });
            }, 1);
        }

        var prefinished = function () {
            prewraper.animate({
                "opacity": "1"
            }, 50).promise().done(function () {
                prewraper.remove();
                wrap.css({
                    "height": "100%",
                    "width": "100%"
                });
                init();
            });
        }

        /* ============================================================
		   Tankbar Setup
		   ============================================================ */

        if (el.children('.slideWrp').length < 2) {
            self.slider.setup.autoplay = false;
            self.slider.setup.bullets = false;
            self.slider.setup.swipe = false;
        }

        // Autoslide

        var addSeconds = function () {
            if (self.slider.setup.autoplay) {
                addTime = currentTime++;
                timer(addTime);
            }
        }

        self.interval = setInterval(addSeconds, 1000);

        // Timer
        var timer = function (timeLeft) {
            if (timeLeft == self.slider.setup.duration / 1000) {
                currentTime = 1;
                index();
            }
        }


        var init = function () {

            // Responsive
            if (self.slider.setup.responsive) $(window).on('resize', function () {
                resize(self);
                currentTime = 1;
            });

            // Förebygger flera klick samtidigt
            if (self.slider.setup.preventclicking) preventClick = false;

            // Förebyggger bilder som fastnar vid muspekaren när man drar
            if (self.slider.setup.preventDragImage) $("img").bind('dragstart', function () {
                return false;
            });

            // Array för slides
            self.slider.defaultIndexes = [];
            self.slider.active = [];
            self.slider.activeOld = [];
            self.slider.activeLast = self.slider.setup.show - 1;
            self.slider.activeFirst = self.slider.setup.startIndex;
            self.slider.directions = "next";
            self.slider.setindex = self.slider.setup.startIndex;
            self.slider.current = "";

            // Elements
            self.slider.pager = "";
            self.slider.arrownext = "";
            self.slider.arrowprev = "";

            // Sätter våra Slides
            self.slider.children = el.children(".slideWrp");
            self.slider.children.index = (self.slider.children.length - 1);

            // Uppdaterar storleken på slides
            if (self.slider.setup.customstyle == true) {
                self.slider.setup.widthNomargin = el.children().outerWidth();
                self.slider.setup.width = el.children().outerWidth(true);
                self.slider.setup.heightNomargin = el.children().outerHeight();
                self.slider.setup.height = el.children().outerHeight(true);
            } else {
                self.slider.setup.widthNomargin = wrap.outerWidth();
                self.slider.setup.width = wrap.outerWidth(true);
                self.slider.setup.heightNomargin = wrap.outerHeight();
                self.slider.setup.height = wrap.outerHeight(true);
            }

            // Vi kan inte visa mer slides än vad vi har
            if (self.slider.setup.show > self.slider.children.length) self.slider.setup.show = self.slider.children.length;

            // Vi kan inte gå fler steg än vad vi visar
            if (self.slider.setup.slide > self.slider.setup.show) self.slider.setup.slide = self.slider.setup.show;

            // Pause slide on resize
            if (self.slider.setup.autoplay) {
                if (self.slider.setup.hoverpause) self.slider.children.hover(function () {
                    clearInterval(self.interval);
                }, function () {
                    self.interval = setInterval(addSeconds, 1000);
                });
            }

            // Skapar div för Arrows
            if (self.slider.setup.arrow) {
                wrap.append("<div class='tNav'><div class='prev fa fa-angle-left'>" + self.slider.setup.prevTxt + "</div><div class='next fa fa-angle-right'>" + self.slider.setup.nextTxt + "</div></div>");
                self.slider.arrownext = wrap.find(".tNav .next");
                self.slider.arrowprev = wrap.find(".tNav .prev");

                self.slider.arrownext.click(function (e) {
                    if (preventClick != true) {
                        e.preventDefault();
                        currentTime = 0;
                        firstDirection = "next";
                        index();
                    }
                });

                self.slider.arrowprev.click(function (e) {
                    if (preventClick != true) {
                        e.preventDefault();
                        currentTime = 0;
                        firstDirection = "prev";
                        index(undefined, "prev");
                    }
                });

                if (self.slider.children.length > self.slider.setup.show && !self.slider.setup.fadeArrows) {
                    $(".tNav").show();
                } else {
                    $(".tNav").hide();
                }
            }

            // Skapar div för Bullets
            if (self.slider.setup.bullets)
                if (self.slider.setup.tabs) {
                    createTabs();
                } else {
                    createPager();
                }

            if (self.slider.setup.count)
                createCount();


            setup();

            updateslides();

            if (self.slider.setup.transition == "fade") {
                // Göm alla slides
                el.children().css({
                    "opacity": "0"
                });
                el.children().eq(self.slider.setup.startIndex).css({
                    "opacity": "1",
                    "position": "absolute",
                    "z-index": "9"
                });
            } else {
                // Visa alla slides
                el.children().css({
                    "opacity": "1"
                });
            }

            // Sätter höjden på window
            elHeight();

        } // end

        var createCount = function (countIdx) {
            if (countIdx === undefined)
                countIdx = 0;

            countIdx++;

            if (wrap.find(".tCount").length > 0) {
                wrap.find(".tCount").html("<span>" + countIdx + self.slider.setup.countSplit + self.slider.children.length + " </span>");
            } else {
                wrap.append("<div class='tCount'></div>");
                wrap.find(".tCount").html("<span>" + countIdx + self.slider.setup.countSplit + self.slider.children.length + " </span>");
            }
        }

        var createPager = function () {
            var oldindex = 0;
            var setindex = 0;
            wrap.find(".tPager").remove();
            wrap.append("<div class='tPager'></div>");
            wrap.find(".tPager").html("");
            for (var i = 0; i < Math.floor(self.slider.children.length / self.slider.setup.slide) ; i++) {
                if (self.slider.setup.titles)
                    wrap.find(".tPager").append("<a href='#'>" + el.find(".title").eq(i).text() + "</a>");
                else
                    wrap.find(".tPager").append("<a href='#'>" + (i + 1) + "</a>");
            }
            self.slider.pager = wrap.find(".tPager a");
            self.slider.pager.eq(self.slider.setindex).addClass("current");
            self.slider.pager.click(function (e) {
                e.preventDefault();
                self.slider.oldindex = self.slider.pager.filter(".current").index();
                self.slider.oldIndex = self.slider.pager.filter(".current").index();
                if (preventClick != true) {
                    e.preventDefault();
                    currentTime = 1;
                    var direction;

                    self.slider.setindex = ($(this).index());

                    if (self.slider.setindex < self.slider.oldindex) direction = "prev";
                    else direction = undefined;

                    if (self.slider.setindex != self.slider.oldindex) index(self.slider.setindex, direction);

                    self.slider.oldIndex = self.slider.pager.filter(".current").index();
                    self.slider.oldindex = self.slider.pager.filter(".current").index();

                }
            });
        }

        var createTabs = function () {
            var oldindex = 0;
            var setindex = 0;
            wrap.find(".tTab").remove();
            wrap.append("<div class='tTab'></div>");
            wrap.find(".tTab").html("");
            for (var i = 0; i < Math.floor(self.slider.children.length / self.slider.setup.slide) ; i++) {
                wrap.find(".tTab").append("<a href='#'>" + el.find(".title").eq(i).text() + "</a>");

            }
            self.slider.pager = wrap.find(".tTab a");
            self.slider.pager.eq(self.slider.setindex).addClass("current");
            self.slider.pager.click(function (e) {
                e.preventDefault();
                self.slider.oldindex = self.slider.pager.filter(".current").index();
                self.slider.oldIndex = self.slider.pager.filter(".current").index();
                if (preventClick != true) {
                    e.preventDefault();
                    currentTime = 1;
                    var direction;

                    self.slider.setindex = ($(this).index());

                    if (self.slider.setindex < self.slider.oldindex) direction = "prev";
                    else direction = undefined;

                    if (self.slider.setindex != self.slider.oldindex) index(self.slider.setindex, direction);

                    self.slider.oldIndex = self.slider.pager.filter(".current").index();
                    self.slider.oldindex = self.slider.pager.filter(".current").index();

                }
            });

            // Tabs width function
            $(".tTab").each(function (index) {
                var num = $(this).children("a").length;
                $(this).find("a").each(function () {
                    if (num === 4) {
                        $(this).addClass("tabs4");
                    }
                    if (num === 3) {
                        $(this).addClass("tabs3");
                    }
                    if (num === 2) {
                        $(this).addClass("tabs2");
                    }
                });
            });

        }

        var resizeEl = function (index) {
            var currentHeight = self.slider.children.eq(index).outerHeight(true);
            el.stop(true, true).animate({ "height": currentHeight }, 250);
        }

        var elHeight = function () {
            if (!self.slider.setup.customHeight) {
                if (self.slider.setup.transition == "vertical") el.height(self.slider.children.outerHeight(true) * self.slider.setup.show);
                else {
                    var t_h = 0;
                    var t_e = 0;
                    self.slider.children.each(function () {
                        if ($(this).outerHeight(true) > t_h) {
                            t_h = $(this).outerHeight(true);
                            t_e = $(this).outerHeight(true);
                        }
                    });
                    el.height(t_e);
                    return el.height();
                }
            } else {
                var temp = self.slider.children.outerHeight(true);
                var elTimeout = window.setTimeout(function () {
                    if (self.slider.children.outerHeight(true) != temp) {
                        elHeight();
                        clearInterval(elTimeout);
                    }
                }, 500);
                return el.height(self.slider.children.outerHeight(true));
            }
        }
        var tempAutoplay = self.slider.setup.autoplay;
        // Responsive SLides
        var resize = function () {
            if (self.slider.setup.arrow) {
                if (self.slider.children.length > self.slider.setup.show && !self.slider.setup.fadeArrows) {
                    $(element).find(".tNav").show();
                } else {
                    $(element).find(".tNav").hide();
                }
                if ($(element).find(".tNav").css("display") != "block" && !self.slider.setup.fadeArrows) {
                    $(element).find(".tNav").stop(true, true).fadeIn(300);
                }
            }
            if (tempAutoplay !== self.slider.setup.autoplay && self.slider.setup.autoplay === false) {
                clearInterval(self.interval);
            } else if (tempAutoplay !== self.slider.setup.autoplay && self.slider.setup.autoplay === true) {
                if (self.interval)
                    clearInterval(self.interval);
                self.interval = setInterval(addSeconds, 1000);
            }

            // Init show
            var oldnumber = self.slider.setup.slide;

            // Update pager numbers
            if (oldnumber != self.slider.setup.slide) {
                createPager();
            }

            // Update positions off slides
            positions();

            // Relative window size
            resizeEl(self.slider.active[0]);
            // Equal Heights
            if (self.slider.setup.equalheight) {
                setTimeout(function () {
                    // Get Equal heights
                    $(".sf_cols").siblings().each(function () {
                        $(this).find('.equal').height('auto');
                        $(this).find('.equal').equalHeights();
                    });
                    $('.referenceItem').height('auto');
                    $('.referenceItem').equalHeights();
                }, 150);
            }
            tempAutoplay = self.slider.setup.autoplay;
        } // end
        var setup = function () {
            // Skriver till array
            if (self.slider.setup.show == 1) {
                self.slider.active.push(self.slider.children.eq(self.slider.setup.startIndex).index());
                self.slider.activeOld.push(self.slider.children.eq(self.slider.setup.startIndex).index());
            } else {
                for (var i = 0; i < self.slider.setup.show; i++) {
                    self.slider.active.push(self.slider.children.eq(i).index());
                    self.slider.activeOld.push(self.slider.children.eq(i).index());
                }
            }

            start();
        } // end
        var start = function () {
            for (var i = 0; i < self.slider.active.length; i++) {
                if (self.slider.setup.transition == "vertical") self.slider.children.eq(self.slider.active[i]).addClass("visible").css({
                    top: (self.slider.setup.width * i) + "px"
                });
                else self.slider.children.eq(self.slider.active[i]).addClass("visible").css({
                    left: (self.slider.setup.height * i) + "px"
                });
            }

        } // end
        var index = function (setindex, direction) {
            resize();
            self.slider.activeOld = self.slider.active.slice();
            var newIndex = 0;
            if (setindex > -1) {

                if (setindex > self.slider.oldIndex) {
                    direction = undefined;
                } else {
                    direction = "prev";
                }
                if (self.slider.oldIndex == 0 && (setindex) == Math.floor(self.slider.children.length / self.slider.setup.slide)) {
                    direction = "prev";
                }

                if (direction == "prev") {
                    var page = Math.abs(self.slider.oldIndex - setindex);
                    newIndex = Math.abs(self.slider.active[0] - (page * self.slider.setup.slide));
                    for (var i = 0; i < self.slider.active.length; i++) {
                        self.slider.active[i] = Math.abs(newIndex + i);
                    }
                } else {
                    var page = Math.abs(self.slider.oldIndex - setindex);
                    if ((self.slider.oldIndex + 1) == Math.floor(self.slider.children.length / self.slider.setup.slide) && (setindex + 1) == 1) {
                        newIndex = 0;
                    } else {
                        newIndex = Math.abs((page * self.slider.setup.slide) + self.slider.active[0]);
                    }
                    for (var i = 0; i < self.slider.active.length; i++) {
                        self.slider.active[i] = Math.abs(newIndex + i);
                    }
                }

                if ((setindex + 1) == Math.floor(self.slider.children.length / self.slider.setup.slide)) {

                    var diff = Math.abs(self.slider.active[self.slider.setup.show - 1] - (self.slider.children.length - 1));
                    if (diff < 0) diff = 0;
                    self.slider.active.splice(self.slider.setup.show - diff, self.slider.setup.show);
                    var getnewindex = 0;
                    for (var i = 0; i < self.slider.setup.show; i++) {
                        if (typeof self.slider.active[i] == 'undefined') {
                            self.slider.active[i] = getnewindex;
                            getnewindex++
                        }
                    }
                }

            } else {
                if (direction == "prev") for (var i = 0; i < self.slider.setup.show; i++) {
                    newIndex = self.slider.active[i] - self.slider.setup.slide;
                    if (newIndex > -1) self.slider.active[i] = newIndex;
                    else self.slider.active[i] = self.slider.children.index + newIndex + 1;
                } else for (var i = 0; i < self.slider.setup.show; i++) {
                    newIndex = self.slider.active[i] + self.slider.setup.slide;
                    if (newIndex > self.slider.children.index) self.slider.active[i] = (newIndex - self.slider.children.index - 1);
                    else self.slider.active[i] = newIndex;
                }
            }

            self.slider.activeOld = $.grep(self.slider.activeOld, function (n, i) {
                return $.inArray(n, self.slider.active) == -1;
            });

            resizeEl(self.slider.active[0]);
            animate(direction);

        } // end
        var animate = function (direction) {
            preventClick = true;
            if (self.slider.setup.transition == "horizontal") eventHorizontal(direction);
            if (self.slider.setup.transition == "fade") eventFade(direction);
            if (self.slider.setup.transition == "vertical") eventVertical(direction);
            if (self.slider.setup.bullets || self.slider.setup.count)
                updatePagerIndex();
        } // end
        var positions = function () {
            // Uppdaterar storleken på slides
            if (self.slider.setup.customstyle == true) {
                self.slider.setup.widthNomargin = el.children().outerWidth();
                self.slider.setup.width = el.children().outerWidth(true);
                self.slider.setup.heightNomargin = el.children().outerHeight();
                self.slider.setup.height = el.children().outerHeight(true);
            } else {
                self.slider.setup.widthNomargin = wrap.outerWidth();
                self.slider.setup.width = wrap.outerWidth(true);
                self.slider.setup.heightNomargin = wrap.outerHeight();
                self.slider.setup.height = wrap.outerHeight(true);
            }

            // Uppdaterar index
            ///
            self.slider.active = self.slider.active.slice(0, self.slider.setup.show);
            var createIndex = (self.slider.active[self.slider.active.length - 1] + 1)
            if (self.slider.active.length < self.slider.setup.show) {
                if (createIndex > self.slider.children.index) self.slider.active.push(createIndex - self.slider.children.index - 1);
                else self.slider.active.push(createIndex);
            }
            updateslides();
        } // end
        var updateslides = function (data) {
            if (self.slider.setup.transition == "vertical") {
                self.slider.children.css({
                    "top": -self.slider.setup.height,
                    "height": self.slider.setup.heightNomargin
                }).removeClass("visible");
            } else {
                self.slider.children.css({
                    "left": -self.slider.setup.width,
                    "width": self.slider.setup.widthNomargin
                }).removeClass("visible");
            }
            for (var i = 0; i < self.slider.active.length; i++) {
                if (self.slider.setup.transition == "vertical") {
                    self.slider.children.eq(self.slider.active[i]).css({
                        "top": (self.slider.setup.height * i) + "px",
                        "height": self.slider.setup.heightNomargin
                    }).addClass("visible");
                } else {
                    self.slider.children.eq(self.slider.active[i]).css({
                        "left": (self.slider.setup.width * i) + "px",
                        "width": self.slider.setup.widthNomargin
                    }).addClass("visible");
                }
            }

        } // end
        var eventFade = function (direction) {
            self.slider.children.css({
                "opacity": "0",
                "z-index": "0"
            });
            for (var i = 0; i < self.slider.activeOld.length; i++) {
                self.slider.children.eq(self.slider.activeOld[i]).css({
                    "opacity": "1",
                    "z-index": "0"
                }).animate({
                    "opacity": "0"
                }, {
                    duration: self.slider.setup.transTime,
                    queue: false,
                    specialEasing: {
                        opacity: self.slider.setup.easing
                    }
                }).promise().done(function () {
                    preventClick = false;
                    $(this).removeClass("visible");
                });
            }
            for (var i = 0; i < self.slider.active.length; i++) {
                self.slider.children.eq(self.slider.active[i]).css({
                    "opacity": "0",
                    "z-index": "9",
                    "left": self.slider.children.eq(self.slider.activeOld[i]).outerWidth(true) * i
                }).animate({
                    "opacity": "1"
                }, {
                    duration: self.slider.setup.transTime,
                    queue: false,
                    specialEasing: {
                        opacity: self.slider.setup.easing
                    }
                }).promise().done(function () {

                })
            }
        } // end
        var eventHorizontal = function (direction) {
            self.slider.children.css({
                opacity: 1,
                zIndex: 0
            });
            for (var i = 0; i < self.slider.activeOld.length; i++) {
                var next = -((self.slider.setup.width * self.slider.setup.slide) - (self.slider.setup.width * i));
                var prev = "+=" + (self.slider.setup.width * self.slider.setup.slide);
                self.slider.children.eq(self.slider.activeOld[i]).stop(true, true).animate({
                    "left": (direction) ? prev : next
                }, {
                    duration: self.slider.setup.transTime,
                    queue: false,
                    specialEasing: {
                        left: self.slider.setup.easing
                    }
                }).promise().done(function () {
                    preventClick = false;
                });

            }
            for (var i = 0; i < self.slider.active.length; i++) {
                var next = self.slider.setup.width;
                var prev = self.slider.setup.width;
                var cssnext = ((self.slider.setup.width * self.slider.setup.slide) + (self.slider.setup.width * i));
                var cssprev = -((self.slider.setup.width * self.slider.setup.slide) - (self.slider.setup.width * i));
                self.slider.children.eq(self.slider.active[i]).css({
                    zIndex: i + 1,
                    "left": (direction) ? cssprev : cssnext,
                    "width": self.slider.setup.widthNomargin
                }).animate({
                    "left": self.slider.setup.width * i
                }, {
                    duration: self.slider.setup.transTime,
                    queue: false,
                    specialEasing: {
                        left: self.slider.setup.easing
                    }
                }).promise().done(function () {

                })
            }
        } // end
        var eventVertical = function (direction) {
            self.slider.children.css({
                zIndex: 0,
                left: 0
            });
            for (var i = 0; i < self.slider.activeOld.length; i++) {
                var next = -((self.slider.setup.height * self.slider.setup.slide) - (self.slider.setup.height * i));
                var prev = "+=" + (self.slider.setup.height * self.slider.setup.slide);
                self.slider.children.eq(self.slider.activeOld[i]).animate({
                    "top": (direction) ? prev : next
                }, {
                    duration: self.slider.setup.transTime,
                    queue: false,
                    specialEasing: {
                        top: self.slider.setup.easing
                    }
                }).promise().done(function () {
                    preventClick = false;
                });

            }
            for (var i = 0; i < self.slider.active.length; i++) {
                var next = self.slider.setup.height
                var prev = self.slider.setup.height
                var cssnext = ((self.slider.setup.height * self.slider.setup.slide) + (self.slider.setup.height * i));
                var cssprev = -((self.slider.setup.height * self.slider.setup.slide) - (self.slider.setup.height * i));
                self.slider.children.eq(self.slider.active[i]).css({
                    zIndex: i + 1,
                    "top": (direction) ? cssprev : cssnext,
                    "height": self.slider.setup.heightNomargin
                }).animate({
                    "top": self.slider.setup.height * i
                }, {
                    duration: self.slider.setup.transTime,
                    queue: false,
                    specialEasing: {
                        top: self.slider.setup.easing
                    }
                }).promise().done(function () {

                }).addClass("visible");
            }
        } // end

        // Swipe
        el.on("vmousedown", function (e) {
            if (self.slider.setup.swipe == true) {
                $("img").bind('dragstart', function () {
                    return false;
                });
                drag = true;
                dragSX = e.pageX;
                dragSY = e.pageY;
            }

        });
        el.on("vmouseup", function (e) {
            if (self.slider.setup.swipe == true) {
                drag = null;
                dragEX = e.pageX;
                dragEY = e.pageY;
                if (dragEX > (dragSX + 100) && Math.abs(dragEY - dragSY) < 100) {
                    currentTime = 0;
                    index(undefined, "prev");
                } else if ((dragEX + 100) < dragSX && Math.abs(dragEY - dragSY) < 100) {
                    currentTime = 0;
                    index();
                }
            }
        });

        var faded;
        $(element).find(".tSliderWrp, .tNav").on("vmouseover", function () {
            if (self.slider.setup.fadeArrows === false) {
                $(element).find(".tNav").stop(true, true).fadeIn(300);
                clearInterval(faded);
            } else {
                if ($(element).find(".tNav").css("display") != "block") {
                    $(element).find(".tNav").stop(true, true).fadeIn(300);
                }
                clearInterval(faded);
            }
        });

        $(element).find(".tSliderWrp").on("vmouseout", function () {
            if (self.slider.setup.fadeArrows === false) {
                $(element).find(".tNav").stop(true, true).fadeIn(300);
                clearInterval(faded);
            } else {
                faded = setInterval(function () {
                    if ($(element).find(".tNav").css("display") == "block") {
                        $(element).find(".tNav").stop(true, true).fadeOut(300);
                    }
                }, 500);
            }
        });

        var updatePagerIndex = function () {
            var page;
            var slides = [];
            for (var i = 0; i < self.slider.children.length; i++) {
                slides.push(i);
            }
            var index = 0;
            while (slides.length > 0) {
                chunk = slides.splice(0, self.slider.setup.slide)
                if (self.slider.active[0] == chunk[0] && self.slider.setup.bullets) {
                    self.slider.pager.removeClass("current").eq(index).addClass("current");
                }
                if (self.slider.active[0] == chunk[0] && self.slider.setup.count) {
                    createCount(index);
                }
                index++;
            }

        } //end

        if (self.slider.setup.preloader == true) preloader();
        else
            if (isinit)
                init();

        return self;

    } // end

}(jQuery));
